import { TaskModel, TasksAndCountModel } from "@teamprevent/common/task/taskActions/models";
import { CaseConversationTaskModel } from "@teamprevent/common/messaging/models";

import { CurrentUser } from "../auth";
import { AdminUserInRedux } from "../crud/adminUser";
import { ImmunisationTaskModel } from "../task/model";

export interface ActionableTasksState {
    actionableTasks: TasksAndCountModel;
    currentUser: CurrentUser;
    adminUsers: AdminUserInRedux[];
}

export type SelectableTask = (TaskModel | ImmunisationTaskModel | CaseConversationTaskModel) & { selected: boolean };

export interface OptionValue {
    id: string;
    name: string;
}

export const ALL_ADMIN_USERS = "All";

export const ALL_ADMIN_USERS_VALUE: OptionValue = { id: ALL_ADMIN_USERS, name: ALL_ADMIN_USERS };

export const ALL_ADMIN_USERS_OPTION = { key: ALL_ADMIN_USERS, value: ALL_ADMIN_USERS, text: ALL_ADMIN_USERS };
